import React from 'react';
// Assuming the image is stored in your assets folder
import SansmrutiBook from '../../assets/images/SansmrutiBook.jpeg'; 

const SansmrutiBookReleases = () => {
    return (
        <div style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9', minHeight: '100vh' }}>
            <h1 style={{ marginBottom: '30px', color: '#333' }}>दावडी ते रामधाम - Book Release</h1>
            
            {/* Centering Wrapper */}
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center',
                margin: '0 auto',
                width: '100%'
            }}>
                <img 
                    src={SansmrutiBook} 
                    alt="दावडी ते रामधाम Book Cover" 
                    style={{ 
                        width: '100%', 
                        maxWidth: '800px', // Adjusted slightly for a cleaner look
                        height: 'auto', 
                        borderRadius: '8px',
                        boxShadow: '0 15px 30px rgba(0,0,0,0.15)',
                        display: 'block'
                    }} 
                />
            </div>

            <div style={{ 
                marginTop: '30px', 
                fontSize: '1.2rem', 
                fontWeight: 'bold', 
                lineHeight: '1.6' 
            }}>
                <p style={{ margin: '5px 0' }}>सैनिक रामभाऊ द. सातपुते यांची आत्मकथा</p>
                <p style={{ margin: '5px 0', color: '#555' }}>शब्दांकन : विनय रामभाऊ सातपुते</p>
            </div>
        </div>
    );
}

export default SansmrutiBookReleases;